import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_home/leads')({
  component: LeadsLayout,
})

function LeadsLayout() {
  return <Outlet />
}
